/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import getColor from "@insite/mobius/utilities/getColor";
import { imageHoverEffect } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

categoriesStyles.container = {};

categoriesStyles.title = {
    variant: "h3",
    as: "h2",
    lineHeight: "30px",
    color: "secondary.main",
};

categoriesStyles.categoryContainer = {
    gap: 15,
};

categoriesStyles.innerCategoryContainer = {
    gap: 0,
    css: css`
        &&& {
            width: 100%;
        }
    `,
};

categoriesStyles.categoryImageItem = {
    width: 12,
    css: css`
        &&& {
            margin-bottom: 15px;
        }
    `,
};

categoriesStyles.categoryNameLinkItem = {
    width: 12,
    css: css`
        &&& {
            text-align: center;
            justify-content: center;

            &.there-are-subcategories {
                margin-bottom: 5px;
            }
        }
    `,
};

categoriesStyles.subCategoryItem = {
    width: 12,
    css: css`
        &&& {
            text-align: center;
            justify-content: center;
            margin-top: 5px;
        }
    `,
};

categoriesStyles.categoryImageLink = {
    css: css`
        &,
        > * {
            width: 100%;
        }
    `,
};

categoriesStyles.categoryImage = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        border: 1px solid ${getColor("common.ui12")};
        background: ${getColor("common.background")};
        height: 126px;
        overflow: hidden;
        width: 100%;

        img {
            object-fit: cover;
            object-position: center center;
            height: 100%;
        }

        ${imageHoverEffect};

        &:hover,
        &:focus {
            &:after {
                opacity: 1;
            }
        }
    `,
};

categoriesStyles.categoryNameLink = {
    typographyProps: {
        size: "16px",
        weight: 700,
        lineHeight: "22px",
    },
};

categoriesStyles.categoryItemRow = {
    width: [12, 6, 4, 3, 2],
    css: css`
        padding-bottom: 30px;
    `,
};
